/* Copyright (c) 2018 Verge Technologies
 * @file subscriptionBanner.js
 * @author Brenton Watt
 * @description Component responsible for displaying the newsletter subscription banner
 */

import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import validator from 'validator';

import { SUBSCRIBE_EMAIL } from '../../graphql';

class SubscriptionBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // Handler for subscription to newsletter banner submission
  handleSubmit(e, mutation) {
    e.preventDefault();
    // Check the value in state is a valid email
    if (validator.isEmail(this.state.email)) {
      mutation();
      this.setState({
        ...this.state,
        email: '',
      });
    }
  }

  render() {
    return (
      <div className="subscribe-container">
        <h5 style={{ color: 'white' }}>Stay up to date with our latest products.</h5>
        <p>Get monthly updates.</p>
        <Mutation mutation={SUBSCRIBE_EMAIL} variables={{ email: this.state.email }}>
          {(postMutation) => {
            return (
              <div className="form">
                <input
                  type="email"
                  autoComplete="off"
                  name="email"
                  placeholder="Email..."
                  value={this.state.email}
                  onChange={(e) => {
                    this.setState({
                      ...this.state,
                      email: e.target.value,
                    });
                  }}
                />
                <a href={null} className="button button-green" onClick={e => this.handleSubmit(e, postMutation)}>
                  Subscribe
                </a>
              </div>
            );
          }}
        </Mutation>
      </div>
    );
  }
}

export default SubscriptionBanner;



// WEBPACK FOOTER //
// ./src/components/SubscriptionBanner/subscriptionBanner.js